import React, { Component } from "react";
import Subscribes from "./subscribes/subscribes";
import VideoList from "./videos/videoList";
import StreamingInfo from "./streamingInfo/streamingInfo";
import getVideos from "../services/videoService";
import LoadingStatus from "../constants/loadingStatus";
import StorageManager from "../utilities/storageManager";
import {
  validateCategoryValue,
  getInternalValueFromParent,
  sendOptionValueToParent,
} from "./contentHelper";
import postMessageToParent from "../utilities/postMessage";
import ValidDomains from "../constants/valid-domain-list.json";
import queryString from "query-string";

class Content extends Component {
  static storagePropName = "microsoft-dotnet-website-community-selections";

  constructor(props) {
    super(props);

    this.state = {
      videos: [],
      selectedItem: "",
      selectedItemSnapshot: null,
      loadingStatus: LoadingStatus.notStart,
      isInitializing: true,
    };

    this.containerRef = React.createRef();
    this.resizeObserver = null;
    this.debounceTimeout = null;
  }
  componentDidMount() {
    // Set up ResizeObserver to detect content size changes
    this.setupResizeObserver();
    // Get stored selection as initial value
    const storedSelection = StorageManager.read(Content.storagePropName) || "";
    const validSelectionValue = validateCategoryValue(storedSelection)
      ? storedSelection
      : "";

    this.setState(
      {
        selectedItem: validSelectionValue,
        selectedItemSnapshot: validSelectionValue,
        loadingStatus: LoadingStatus.notStart,
      },
      async () => {
        await this.loadVideos(this.state.selectedItem);
        this.setState({ isInitializing: false });
      },
    );

    window.addEventListener("message", this.handleMessage);

    // Send a ready signal to parent to indicate we're ready to receive messages
    if (window.parent !== window) {
      const targetOrigin = this.getValidatedParentOrigin();
      if (targetOrigin) {
        window.parent.postMessage({ iframeReady: true }, targetOrigin);
      }
    }
  }

  componentWillUnmount() {
    // Clean up ResizeObserver
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    // Clean up debounce timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = null;
    }
    window.removeEventListener("message", this.handleMessage);
  }

  setupResizeObserver = () => {
    if (this.containerRef.current && "ResizeObserver" in window) {
      this.resizeObserver = new ResizeObserver(() => {
        // Debounce the postMessage calls to avoid excessive messaging
        if (this.debounceTimeout) {
          clearTimeout(this.debounceTimeout);
        }

        this.debounceTimeout = setTimeout(() => {
          postMessageToParent();
          this.debounceTimeout = null;
        }, 50);
      });

      this.resizeObserver.observe(this.containerRef.current);
    }
  };

  getValidatedParentOrigin = () => {
    const values = queryString.parse(window.location.search.toLowerCase());
    const domain = values.domain;
    if (domain && ValidDomains[domain]) {
      return domain;
    }
    return null;
  };

  updateSelectedItem = (e) => {
    const newValue = e.target.value;

    if (newValue === this.state.selectedItem) {
      return; // No change, do nothing
    }

    this.setState({
      selectedItem: newValue,
      selectedItemSnapshot: newValue,
    });

    StorageManager.save(Content.storagePropName, newValue);

    sendOptionValueToParent(newValue);

    this.loadVideos(newValue);
  };
  handleMessage = (e) => {
    // Validate origin of incoming messages
    if (e.origin && !ValidDomains[e.origin]) {
      return; // Ignore messages from untrusted origins
    }

    const data = e.data;

    if (data.categoryFromParent !== undefined) {
      const fullCategory = getInternalValueFromParent(data.categoryFromParent);

      // Only update if the category is valid and different from current
      if (fullCategory !== null && this.state.selectedItem !== fullCategory) {
        this.setState({
          selectedItem: fullCategory,
          selectedItemSnapshot: fullCategory,
        });

        // Save to storage when parent sends category
        StorageManager.save(Content.storagePropName, fullCategory);

        this.loadVideos(fullCategory);
      }
    }
  };
  requeryVideos = () => {
    const { selectedItemSnapshot, selectedItem } = this.state;
    if (selectedItemSnapshot != selectedItem) {
      this.loadVideos(selectedItem);
      StorageManager.save(Content.storagePropName, selectedItem);
      this.setState({
        selectedItemSnapshot: selectedItem,
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      !this.state.isInitializing &&
      prevState.selectedItem !== this.state.selectedItem &&
      prevState.selectedItem !== "" &&
      this.state.selectedItemSnapshot === this.state.selectedItem
    ) {
      StorageManager.save(Content.storagePropName, this.state.selectedItem);
    }
  }

  loadVideos = async (categories = this.state.selectedItem) => {
    this.setState({ loadingStatus: LoadingStatus.notStart });

    const videos = await getVideos(categories);

    this.setState({
      videos,
      loadingStatus: LoadingStatus.loaded,
    });
  };

  render() {
    const { loadingStatus, videos } = this.state;

    return (
      <div className="container" ref={this.containerRef}>
        <StreamingInfo videos={videos} source="Standup" />

        <label htmlFor="categoryDropdown" className="dropdown-label">
          Category
        </label>
        <select
          id="categoryDropdown"
          value={this.state.selectedItem || ""}
          onChange={this.updateSelectedItem}
          placeholder="All"
          aria-label="Show Category"
          className="dropdown-category"
        >
          <option value="">All</option>
          <option value=".NET AI">.NET AI</option>
          <option value=".NET MAUI">.NET MAUI</option>
          <option value="ASP.NET">ASP.NET</option>
          <option value="Data">Data</option>
          <option value="Languages & Runtime">Languages & Runtime</option>
        </select>

        <VideoList loadingStatus={loadingStatus} videos={videos} />
        <div className="row justify-content-around pt-60">
          <a
            href="https://www.youtube.com/playlist?list=PLdo4fOcmZ0oX-DBuRG4u58ZTAJgBAeQ-t"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            See More Episodes
          </a>
        </div>
        <Subscribes
          youtubeLink="https://www.youtube.com/dotnet"
          twitchLink="https://twitch.tv/VisualStudio"
        />
      </div>
    );
  }
}

export default Content;
